import "./SurveyTemplateTabPage.scss";

import { Flex } from "@fluentui/react-northstar";
import { dialog } from "@microsoft/teams-js";
import { getAuthoringTaskInfo } from "@teams/client-shared";
import { TeamsApplicationTypes } from "@teams/types";
import { QuestionnaireTemplateDTO } from "@teams/types/api";
import React, { useState } from "react";

import { NavBarNew } from "../../_shared/components/NavBar/NavBarNew";
import {
  ChannelTabNavigationItems,
  NavigationHeader,
} from "../../_shared/components/NavigationHeader";
import { useTheme } from "../../_shared/state/ThemeProvider";
import { getAppId } from "../../_shared/utils/teamsHelpers";
import { TemplateCardList } from "../../survey/pages/SurveyAuthoring/Templates/TemplateCardList";

export const SurveyTemplateTabPage: React.FC = () => {
  const { themeName } = useTheme();

  const applicationType: TeamsApplicationTypes = "msteams";

  const [query, setQuery] = useState<string>("");

  const onUseTemplate = (template: QuestionnaireTemplateDTO) => {
    const taskInfo = getAuthoringTaskInfo(window.location.origin, template.type, applicationType, {
      templateId: template.id,
      theme: themeName,
    });

    dialog.url.bot.open({
      ...taskInfo,
      completionBotId: getAppId(),
    });
  };

  return (
    <Flex column gap="gap.medium" className="template-tab-page">
      <NavBarNew onSearch={async value => setQuery(value)} />

      <NavigationHeader navigationItems={ChannelTabNavigationItems} />

      <TemplateCardList
        searchFilter={query}
        scope="personal"
        onSelect={onUseTemplate}
        actionLabel="Use Template"
      />
    </Flex>
  );
};
